import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class Icon extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }
    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'Icon';
    // Define default properties here
    static instanceDefaults() {
        return {
            paths: [],
            categories: ['all'],
            name: '',
            width: 1024,
            height: 1024,
            active: true,
            cut: true,
            material: true,
            iscategory: false
        }
    }
}
const servicePath = 'icons'
const servicePlugin = makeServicePlugin({
    Model: Icon,
    service: feathersClient.service(servicePath),
    servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
